import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-broullion-inv',
  templateUrl: './broullion-inv.component.html',
  styleUrls: ['./broullion-inv.component.scss']
})
export class BroullionInvComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
